"use client"
import ProductsListAnalytics from '@/app/components/product/ProductsListAnalytics';

const CategoryAnalytics = ({ products, pagination, category }) => {
  return (
    <ProductsListAnalytics products={products} pagination={pagination} listName={`category - ${category?.name}`} />
  )
}

export default CategoryAnalytics;
